import { combineReducers } from 'redux';

const initialState = {
  dict: {},
  list: {
    loadedAll: false,
    loadStatus: 0,
    list: null,
    sort: 3,
    desc: 0,
  },
};

function dictReducer(state = initialState.dict, action) {
  switch (action.type) {
    case 'LOAD_CUSTOMER_COMPLETION': {
      const { customerId, data, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [customerId]: data,
      };
    }

    case 'LOAD_CUSTOMER_LIST_COMPLETION': {
      const { list, error } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        ...list.reduce((obj, customer) => {
          obj[customer.uid] = customer;
          return obj;
        }, {}),
      };
    }

    default:
      return state;
  }
}

function listReducer(state = initialState.list, action) {
  switch (action.type) {
    case 'LOAD_CUSTOMER_LIST': {
      const { sort, desc } = action;
      let list = state.list;

      if (sort !== state.sort || desc !== state.desc) {
        list = null;
      }

      return {
        ...state,
        loadStatus: 1,
        sort,
        desc,
        list,
      };
    }

    case 'LOAD_CUSTOMER_LIST_COMPLETION': {
      const { range, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      const list = action.list.map(customer => customer.uid);

      return {
        ...state,
        loadStatus: 2,
        loadedAll: list.length < range.length,
        count: action.count,
        list: state.list
          ? state.list.slice(0, range.location).concat(list)
          : list,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  dict: dictReducer,
  list: listReducer,
});
